export default {
  RESUME_URL:
    'https://drive.google.com/file/d/1-bYD3OIXzfDr732xt3efoxu1QP6LPCV1/view',
  EMAIL: 'contact@ahmedhatem.com'
}
